import Switch from 'antd/lib/switch';
import 'antd/lib/switch/style/index.css';
import './index.css';

export default Switch;
